import { createHighlighterCore, type HighlighterCore } from 'shiki/core'
import { createJavaScriptRegexEngine } from 'shiki/engine/javascript'

import { createFPlusGrammar } from './fplusGrammar'
import {
  createFPlusTextMateThemes,
  type FPlusThemeProps,
} from './fplusTextMateThemes'

export type FPlusHighlighterProps = FPlusThemeProps & {
  /** The language id the grammar is loaded under, and so the name Shiki highlights by. */
  languageId: string
}

export function createFPlusHighlighter({
  languageId,
  ...themeProps
}: FPlusHighlighterProps): Promise<HighlighterCore> {
  return createHighlighterCore({
    engine: createJavaScriptRegexEngine(),
    themes: createFPlusTextMateThemes(themeProps),
    langs: [createFPlusGrammar(languageId)],
  })
}

let highlighter: Promise<HighlighterCore> | undefined
let loadedHighlighter: HighlighterCore | undefined

/**
 * The one F-plus highlighter, shared by every consumer so the grammar and the
 * themes are loaded exactly once.
 */
export function getFPlusHighlighter(
  props: FPlusHighlighterProps,
): Promise<HighlighterCore> {
  highlighter ??= createFPlusHighlighter(props).then((created) => {
    loadedHighlighter = created

    return created
  })

  return highlighter
}

/**
 * The shared highlighter once it has finished loading, and `undefined` until
 * then. It lets consumers that render synchronously — a React component, say —
 * highlight without waiting when the highlighter is already there.
 */
export function getLoadedFPlusHighlighter(): HighlighterCore | undefined {
  return loadedHighlighter
}
